import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";
import { objectToQuery } from "../../ObjectToQuery";

export class GetStateResponse {
    name!: string;
    native_name!: string;
    id!: number;
    state_id!: number;
    country_id!: number;
}

class GetStatesQuery {
    q?: string;
    page? = 0;
    per_page? = 40
}

export function getStates(country_id = 103,params?: GetStatesQuery): Promise<AxiosResponse<GetStateResponse[]>> {    
    const query = `/countries/${country_id}/states?${objectToQuery(params)}`;
    return Cirus.get(query);
}